export const carga = [
    {
      "EQUIPOS ELECTRONICOS": "Cabezal Sin Furgón de 0 kg",
      "KM / Factor / Galones": 12
    },
    {
      "EQUIPOS ELECTRONICOS": "Cabezal con Furgón Vacío 1 a 2,999.99 kg",
      "KM / Factor / Galones": 9.50
    },
    {
      "EQUIPOS ELECTRONICOS": "Carga liviana de 3,000 a 8,000.00 Kg",
      "KM / Factor / Galones": 8.60
    },
    {
      "EQUIPOS ELECTRONICOS": "Carga liviana de 8,001 a 12,999.99 Kg",
      "KM / Factor / Galones": 8.00
    },
    {
      "EQUIPOS ELECTRONICOS": "Carga liviana de 13,001 a 17,999.99 Kg",
      "KM / Factor / Galones": 7.55
    },
    {
      "EQUIPOS ELECTRONICOS": "Cargado de 18,000 a 21,000.00 Kg",
      "KM / Factor / Galones": 7.26
    },
    {
      "EQUIPOS ELECTRONICOS": "Peso de 21,001 a 23,999.99 Kg",
      "KM / Factor / Galones": 7.00
    },
    {
      "EQUIPOS ELECTRONICOS": "Pesado de 24,000 a 26,999.99 Kg",
      "KM / Factor / Galones": 6.58
    },
    {
      "EQUIPOS ELECTRONICOS": "Sobre Peso de 27,000 a 30,000 kg",
      "KM / Factor / Galones": 6.23
    }
  ] 